import {
  GetCareerManagersDetailsResponse,
  GetCareerManagersResponse,
} from "../../../types/api/careerManagers.type";
import { QueryParam } from "../../../types/api/generic.type";
import { createQueryParamString } from "../../../utils/queryParams.utils";
import httpClient from "../../client/HttpClient";

const CareerManagersService = {
  async list(
    pageSize: number,
    pageNumber: number,
    queryParams?: QueryParam[],
    signal?: AbortSignal,
  ): Promise<GetCareerManagersResponse> {
    const params = queryParams ? createQueryParamString(queryParams) : "";

    const response = await httpClient.get<GetCareerManagersResponse>(
      `v1/career-managers?pageSize=${pageSize}&pageNumber=${pageNumber}${params}`,
      { signal },
    );
    return response;
  },
  async get(
    careerManagerId: string,
  ): Promise<GetCareerManagersDetailsResponse> {
    const response = await httpClient.get<GetCareerManagersDetailsResponse>(
      `v1/career-managers/${careerManagerId}`,
    );
    return response;
  },
};

export default CareerManagersService;
